<script setup lang="ts">
  import { onBeforeUnmount, onMounted, ref } from "vue"

  const widgetRef = ref<HTMLElement>()
  let scriptEl: HTMLScriptElement | null = null

  onMounted(() => {
    const script = document.createElement("script")
    script.src =
      "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
    script.async = true
    script.onload = () => {
      if (window.Trustpilot && widgetRef.value) {
        window.Trustpilot.loadFromElement(widgetRef.value)
      }
    }
    document.head.appendChild(script)
    scriptEl = script
  })

  onBeforeUnmount(() => {
    if (scriptEl) {
      scriptEl.remove()
    }
  })
</script>

<template>
  <div
    ref="widgetRef"
    class="trustpilot-widget w-40"
    data-testid="trustpilot-widget"
    data-locale="en-GB"
    data-template-id="53aa8807dec7e10d38f59f32"
    data-businessunit-id="564319760000ff00058565a8"
    data-style-width="100%"
    data-style-height="80px"
    data-token="758f8715-e751-4ae2-bf6a-75c4f4b18cae"
  >
    <a
      href="https://uk.trustpilot.com/review/so.energy"
      target="_blank"
      rel="noopener noreferrer"
      >Trustpilot</a
    >
  </div>
</template>
